module.exports = __webpack_public_path__ + "static/media/hotRoute.8646fc44.svg";